// Metro/Expo automatically resolves .web.ts and .native.ts extensions
// This allows platform-specific code without runtime checks
export {
  API_BASE,
  APP_ENV,
  IS_PRODUCTION,
  IS_DEVELOPMENT,
  IS_DEMO,
} from './config';

// Demo credentials
export const DEMO_CREDENTIALS = {
  user: {
    username: 'user',
    password: 'user',
    label: 'Demo User',
  },
  admin: {
    username: 'admin123',
    password: 'admin123',
    label: 'Demo Admin',
  },
} as const;
